<template>
  <div class="container">
    <div class="bottom">
      <div class="bottomLeft">
            <img src="../../assets/bottom.png" alt="">
            <span>扫描关注德诚集团公众号</span>
      </div>
      <div class="bottomRight">
            <span>联系我们</span>
            <a href="http://www.decent9999.com/"  target="_blank">德诚官网</a>
            <span>座机：400-086-9999</span>
            <span>总部地址：福建省福州市长乐区鹤上镇珠宝文化创意产业园999号</span>
           <!-- <span>服务时间：24小时</span>
            <span>周一至周五</span> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bottomRegion",
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>


<style scoped>
  a{
    color: #3A3A3A;
    text-decoration: none;
  }
.container {
  width: 100%;
  height: 240px;
  background: #ffffff;
  opacity: 1;
  /* position: absolute;
  bottom: 0px; */
  /* margin: 53px 0 0 0; */
  display: flex;
  justify-content: center;
}
.bottom {
  /* width: 578px; */
  display: flex;
  padding: 23px 0 0 0 ;
}
.bottomLeft{
  display: flex;
  flex-direction: column;
  margin-right: 260px;
  font-size: 14px;
  color: #3A3A3A;
}
.bottomRight{
    display: flex;
    flex-direction: column;
    color: #3A3A3A;
}
.bottomRight>span{
  margin-bottom: 14px;

}
.bottomRight>span:nth-last-of-type{
  margin-bottom: 0px;
}
.bottomRight>span:nth-of-type(1){
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 25px;
  margin-top: 5px;
}
.bottomRight>a{
  margin-bottom: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/bottomRegion/bottomRegion.vue